import React, { useEffect, useState } from "react";
import { FaBars, FaUser } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { TbChecklist } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { MdEmail, MdChecklist } from "react-icons/md";
import "../css/main/Sidebar.css";
import { SidebarProps, MenuItem } from "../Interfaces/Interface"
const Sidebar: React.FC<SidebarProps & { isMobile?: boolean; onSidebarToggle?: (isOpen: boolean) => void }> = ({ isSidebarOpen, toggleSidebar, isMobile = false, onSidebarToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  const [sidebarHover, setSidebarHover] = useState(false);
  const [, setIsDarkMode] = useState(false);
  const [theme, setTheme] = useState<string>("light");
  const [isLandscape, setIsLandscape] = useState(false);
  useEffect(() => {
    const checkOrientation = () => {
      const landscape = isMobile && window.innerWidth > window.innerHeight;
      setIsLandscape(landscape);
    };
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, [isMobile]);
  useEffect(() => {
    if (onSidebarToggle) {
      onSidebarToggle(isSidebarOpen);
    }
  }, [isSidebarOpen, onSidebarToggle]);
  const menuItems: MenuItem[] = [
    { title: "Client", icon: <FaUser />, action: () => navigate("/client"), isActive: location.pathname === "/client" },
    { title: "IdpConfiguration", icon: <RiShieldKeyholeLine />, action: () => navigate("/idpConfiguration"), isActive: location.pathname === "/idpConfiguration" },
    { title: "Checklist Management", icon: <TbChecklist />, action: () => navigate("/checklistmanagement"), isActive: location.pathname === "/checklistmanagement" },
    { title: "Function Checklist Management", icon: <MdChecklist />, action: () => navigate("/functionchecklist"), isActive: location.pathname === "/functionchecklist" },
    { title: "EmailTemplate", icon: <MdEmail />, action: () => navigate("/templates"), isActive: location.pathname === "/templates" },
    { title: "User Management", icon: <FaUser />, action: () => navigate("/usermanagement"), isActive: location.pathname === "/usermanagement" },
  ];
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setIsDarkMode(savedTheme === "dark");
      document.documentElement.setAttribute("data-theme", savedTheme);
      setTheme(savedTheme);
    }
  }, []);
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
    setTheme(newTheme);
  };
  const handleMenuItemClick = (itemAction: () => void) => {
    itemAction();
    if (isMobile && isSidebarOpen) {
      toggleSidebar();
    }
  };
  const shouldShowSidebar = isMobile ? isSidebarOpen : true;
  const onMenuItemClick = (action: () => void) => {
    handleMenuItemClick(action);
  };

  const onMenuItemMouseEnter = (index: React.SetStateAction<number | null>) => {
    if (!isMobile) setHoverIndex(index);
  };

  const onMenuItemMouseLeave = () => {
    if (!isMobile) setHoverIndex(null);
  };

  const onMenuItemKeyPress = (e: { key: string; }, action: () => void) => {
    if (e.key === "Enter") {
      handleMenuItemClick(action);
    }
  };

  return (
    <>
      {shouldShowSidebar && (
        <div className={`sidebar ${isSidebarOpen || sidebarHover ? "open" : ""} ${isLandscape ? 'landscape' : ''} ${isMobile ? 'mobile' : ''}`} onMouseEnter={() => !isMobile && setSidebarHover(true)} onMouseLeave={() => !isMobile && setSidebarHover(false)}>
          <div className="sidebar-logo">
            {(isSidebarOpen || sidebarHover) && (
              <span className="sidebar-logo-text">AuditZen Management</span>
            )}
            {(isSidebarOpen || sidebarHover) && (
              <button onClick={toggleTheme} className="theme-toggle-btn" aria-label={`Current theme: ${theme}`}> {theme === "light" ? "🌞" : "🌙"} </button>
            )}
            <button className="sidebar-toggle-btn" onClick={toggleSidebar} aria-label="Toggle sidebar"><FaBars /></button>
          </div>
          <div className="sidebar-menu">
            {menuItems.map((item, index) => (
              <div key={index} className={`sidebar-menu-item ${hoverIndex === index ? "hover" : ""} ${item.isActive ? "active" : ""}`} onClick={onMenuItemClick.bind(null, item.action)} onMouseEnter={onMenuItemMouseEnter.bind(null, index)} onMouseLeave={onMenuItemMouseLeave} onKeyPress={(e) => onMenuItemKeyPress(e, item.action)} tabIndex={0} aria-label={item.title}>
                <div className="sidebar-menu-icon">{item.icon}</div>
                {(isSidebarOpen || sidebarHover) && (
                  <>
                    <span className="sidebar-menu-title">{item.title}</span>
                    <FiChevronRight className="sidebar-menu-chevron" />
                  </>
                )}
              </div>

            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default Sidebar;